import styled from "styled-components"

import HeroLogo from "components/header/HeroLogo"
import InnerWrapper from "components/InnerWrapper"
import colors from "styles/colors"
import media from "styles/media"

interface Props {
  leftChildren: React.ReactNode
  rightChildren: React.ReactNode
  bgColor?: string
  lightMode?: boolean
  noHeight?: boolean
}

export default function Hero({
  leftChildren,
  rightChildren,
  bgColor = undefined,
  lightMode = undefined,
  noHeight = undefined,
}: Props) {
  return (
    <Wrapper bgColor={bgColor} noHeight={noHeight}>
      <InnerWrapper>
        <Content>
          <CalloutWrapper>
            <HeroLogo lightmode={lightMode} />

            {leftChildren}
          </CalloutWrapper>
          <RightContent>{rightChildren}</RightContent>
        </Content>
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.section<{ bgColor?: string; noHeight?: boolean }>`
  background: ${({ bgColor }) => bgColor || `${colors.blue800}`};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${media.fullWidth} {
    height: ${props => (props.noHeight ? "initial" : "1389px")};
  }

  ${media.desktop} {
    height: ${props => (props.noHeight ? "initial" : "83.67vw")};
  }

  ${media.tablet} {
    height: ${props => (props.noHeight ? "initial" : "133.398vw")};
  }

  ${media.mobile} {
    align-items: unset;
    height: ${props => (props.noHeight ? "initial" : "auto")};
    min-height: ${props => (props.noHeight ? "initial" : "287.333vw")};
  }
`

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  height: 100%;

  ${media.fullWidth} {
    gap: 40px;
  }

  ${media.desktop} {
    gap: 2.41vw;
  }

  ${media.tablet} {
    justify-content: unset;
    flex-direction: column;
    gap: 5.86vw;
  }

  ${media.mobile} {
    justify-content: unset;
    flex-direction: column;
    gap: 0;
  }
`

const CalloutWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${media.fullWidth} {
    padding-top: 91px;
    gap: 119px;
    width: 516px;
  }

  ${media.desktop} {
    padding-top: 5.48vw;
    gap: 7.17vw;
    width: 31.08vw;
  }

  ${media.tablet} {
    width: 58.69vw;
    padding-top: 7.32vw;
    gap: 5.86vw;
  }

  ${media.mobile} {
    width: 100%;
    padding-top: 9.667vw;
    gap: 10.667vw;
    align-items: flex-start;
  }
`

const RightContent = styled.div`
  ${media.fullWidth} {
    width: 736px;
    height: 920px;
  }

  ${media.desktop} {
    width: 44.34vw;
    height: 55.42vw;
  }

  ${media.tablet} {
    width: 100%;
    height: 58.59vw;
  }

  ${media.mobile} {
    width: 100%;
    height: auto;
  }
`
